export { default as ClientsConstants } from './ClientsPage';
export { default as CreateClientConstants } from './CreateClientPage';
export { default as CreateOrderConstants } from './CreateOrderPage';
export { default as CreateReceptionConstants } from './CreateReceptionPage';
export { default as CycleCountConstants } from './CycleCountPage';
export { default as DashboardConstants } from './Dashboard';
export { default as DeltaReceptionsDrawerConstants } from './DeltaReceptionsDrawer';
export { default as EditClientConstants } from './EditClientPage';
export { default as FinancialStatementsConstants } from './FinancialStatementsPage';
export { default as GeneralErrors } from './GeneralErrors';
export { default as integrationsMetadata } from './integrations';
export { default as IntegrationsConstants } from './IntegrationsPage';
export { default as LocationsConstants } from './LocationsPage';
export { default as MultiOrdersConstants } from './MultiOrdersPage';
export { default as CancelOrdersConstants } from './OrderCancel';
export { default as OrderDetailConstants } from './OrderDetailPage';
export { default as OrderPackConstants } from './OrderPackPage';
export { default as OrderPickConstants } from './OrderPickPage';
export { default as OrdersHistoryConstants } from './OrdersHistoryPage';
export { default as OrdersConstants } from './OrdersPage';
export { default as PackagedConstants } from './PackagedPage';
export { default as PostalCodesConstants } from './PostalCodesPage';
export { default as ProductsConstants } from './ProductsPage';
export { default as RayoUploaderConstants } from './RayoUploaderComponent';
export { default as ReceptionsHistoryConstants } from './ReceptionsHistoryPage';
export { default as ReceptionsConstants } from './ReceptionsPage';
export { default as RecollectHistoryConstants } from './RecollectOrdersHistoryPage';
export { default as RecollectOrdersConstants } from './RecollectOrdersPage';
export { default as ReportsConstants } from './ReportsPage';
export * from './ThirdParties';
export { default as WarehouseConstants } from './WarehousePage';
export const SUCCESS_MESSAGE =
  'Gracias por tu paciencia. La operación tuvo exito!';
export const LOADING_MESSAGE = `Solictitud recibida, procesando...`;
